import { render } from "./EventList.vue?vue&type=template&id=e0ce258a&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=e0ce258a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e0ce258a"

export default script